import { DashboardUsageCostChartContainer, DashboardWidget } from '../..'
import { UsageComparisonCard } from '@/features/Analytics/components/UsageComparisonCard/UsageComparisonCard'
import { CostComparisonCard } from '@/features/Analytics/components/CostComparisonCard/CostComparisonCard'
import UsageAndCostContainer from '@/features/Analytics/components/UsageAndCostContainer/UsageAndCostContainer'
import UsageAndCostTitle from '@/features/Analytics/components/UsageAndCostTitle/UsageAndCostTitle'
import UsageAndCostFilterContainer from '@/features/Analytics/components/UsageAndCostFilterContainer/UsageAndCostFilterContainer'

export const DashboardLayout: React.FC = () => {
    const baseWidgetClass = 'col-span-6 xl:col-span-2 h-full'

    return (
        <div className="h-full w-full min-w-minWidgetWidth px-6 pb-6 pt-4">
            <div className="grid gap-6 xl:grid-cols-6">
                <UsageAndCostContainer className="col-span-6 grid grid-cols-6 gap-4">
                    <div
                        className={`${baseWidgetClass} flex items-center justify-between xl:col-span-6`}
                    >
                        <UsageAndCostTitle />
                        <UsageAndCostFilterContainer />
                    </div>

                    <div className={`${baseWidgetClass} xl:col-span-3`}>
                        <UsageComparisonCard />
                    </div>

                    <div className={`${baseWidgetClass} xl:col-span-3`}>
                        <CostComparisonCard />
                    </div>

                    <div className={`${baseWidgetClass} xl:col-span-6`}>
                        <DashboardUsageCostChartContainer />
                    </div>
                </UsageAndCostContainer>

                <div className={`${baseWidgetClass} xl:col-span-3`}>
                    <DashboardWidget />
                </div>
                <div className={`${baseWidgetClass} xl:col-span-3`}>
                    <DashboardWidget />
                </div>

                <div className={baseWidgetClass}>
                    <DashboardWidget />
                </div>
                <div className={baseWidgetClass}>
                    <DashboardWidget />
                </div>
                <div className={baseWidgetClass}>
                    <DashboardWidget />
                </div>

                <div className={baseWidgetClass}>
                    <DashboardWidget />
                </div>
                <div className={baseWidgetClass}>
                    <DashboardWidget />
                </div>
                <div className={baseWidgetClass}>
                    <DashboardWidget />
                </div>
            </div>
        </div>
    )
}
